import type { ReactNode } from "react";
import { pageSizeFor, type SafeScreen } from "../lib/page-layout";

type Props = {
  screen: SafeScreen;
  /** Shopify title bar heading (v7 §28) - sentence case screen name. */
  heading: string;
  children: ReactNode;
  /**
   * Title-bar slots: put `slot="primary-action"`, `slot="secondary-actions"`,
   * `slot="accessory"`, `slot="breadcrumb-actions"` on children.
   */
  actions?: ReactNode;
  /** Convenience: accessory badge (Test mode / Live / plan). */
  accessory?: ReactNode;
  /** Convenience: single primary title-bar action. */
  primaryAction?: ReactNode;
  /** Convenience: secondary title-bar action(s). */
  secondaryActions?: ReactNode;
  /** Back link(s) for sub-pages (BFS 4.1.1). */
  breadcrumb?: ReactNode;
};

/**
 * Shopify App Home page shell - v7 Polaris build map.
 * Title bar only via `s-page` slots; no custom header row.
 */
export function SafePage({
  screen,
  heading,
  children,
  actions,
  accessory,
  primaryAction,
  secondaryActions,
  breadcrumb,
}: Props) {
  return (
    <s-page heading={heading} inlineSize={pageSizeFor(screen)}>
      {breadcrumb}
      {accessory}
      {primaryAction}
      {secondaryActions}
      {actions}
      {children}
    </s-page>
  );
}
